/**
 * Get random integer between two integer values (inclusive).
 * @param {number} min
 * @param {number} max
 * @returns {number} Random integer within boundaries.
 */
const getRandomInteger = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export default getRandomInteger
